import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';

import '@vidstack/react/player/styles/base.css';
import '@vidstack/react/player/styles/plyr/theme.css';


export default function AlertDialog({open,setOpen, children}) {

    const handleClose = () => {
        setOpen(null);
    };

    return (
        <React.Fragment>
            <Dialog
                open={open!=null}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth='lg'
            >
                <DialogContent>
                {children}
                </DialogContent>
            </Dialog>
        </React.Fragment>
    );
}
